import { create } from 'zustand'
import { youTubeChannelClient, youTubePlaylistItemsClient } from '../config/axiosConfig'

interface YouTubeState {
  videoIds: string[]
  loaded: boolean
  error: boolean
}

export const useYouTubeStore = create<YouTubeState>()(() => ({
  videoIds: [],
  loaded: false,
  error: false,
}))

// 1. Resolve the channel's "uploads" playlist id.
// 2. Read the most recent items directly from that playlist.
// This always reflects the latest uploads immediately, unlike the
// YouTube search index which can lag behind by hours or days.
youTubeChannelClient
  .get('')
  .then((channelResponse) => {
    const uploadsPlaylistId =
      channelResponse.data.items?.[0]?.contentDetails?.relatedPlaylists?.uploads

    if (!uploadsPlaylistId) {
      throw new Error('Could not resolve uploads playlist for channel')
    }

    return youTubePlaylistItemsClient.get('', {
      params: { playlistId: uploadsPlaylistId },
    })
  })
  .then((playlistResponse) => {
    const videoIds = playlistResponse.data.items.map(
      (item: { contentDetails: { videoId: string } }) => item.contentDetails.videoId,
    )
    useYouTubeStore.setState({ videoIds: videoIds, loaded: true, error: false })
  })
  .catch((error) => {
    console.error('Error fetching YouTube videos:', error)
    // Make sure the UI leaves the loading state instead of spinning forever.
    useYouTubeStore.setState({ loaded: true, error: true })
  })
